import { Injectable, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { DEFAULT_LANG } from './locale.service';

@Injectable({ providedIn: 'root' })
export class LegalLinksService {
  private readonly currentLang = inject(TranslateService).currentLang;
  // null before a language is loaded, and again when a requested language file fails to load
  private readonly lang = computed(() => this.currentLang() ?? DEFAULT_LANG);
  private readonly base = environment.MAIN_WEBSITE_URL;

  readonly termsUrl = computed(() => `${this.base}/${this.lang()}/merchant-terms-and-conditions`);
  readonly cookiePolicyUrl = computed(() => `${this.base}/${this.lang()}/cookie-policy/`);
  readonly contactUrl = computed(() => `${this.base}/${this.lang()}/contact/`);
}
